<template>
  <v-app-bar app :elevation="0" elevate-on-scroll color="#fff" height="90px" class="px-sm-4">
    <v-app-bar-nav-icon v-if="!sideBar" @click.stop="setSideBar(!sideBar)" />
    <app-breadcrumb :menu="menu" />
    <v-spacer></v-spacer>
    <div class="d-flex align-center navbar-container">
      <div class="self-end d-none d-sm-block">
        <div
          class="font-weight-bold bluePrimary--text mt-2"
          style="line-height: 0.8"
        >
          {{ fullName || "Invitado" }}
        </div>
        <div class="text-caption bluePrimary--text">
          {{ nombrePerfil }}
        </div>
      </div>
      <bell-notification />
      <v-icon size="40" color="#1c1e4d">mdi-account-circle</v-icon>
      <v-icon size="20" color="#1c1e4d">mdi-logout</v-icon>
      <span
        @click="cerrarSession()"
        class="text-decoration-underline"
        style="cursor: pointer; color: #1c1e4d"
      >
        Cerrar sesión
      </span>
    </div>
  </v-app-bar>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import authServices from "../services/auth.services";
import BellNotification from "./BellNotification.vue";
import AppBreadcrumb from "./AppBreadcrumb.vue";

export default {
  name: "AppHeader",
  components: { BellNotification, AppBreadcrumb },
  data: () => ({
    nombrePerfil: "",
    fullName: ""
  }),
  methods: {
    ...mapMutations("utils", ["setSideBar", "setMenu"]),
    ...mapMutations(["setToken"]),

    async cerrarSession() {
      this.$store.commit("utils/setLoader", true);
      let tokenIdentidad = localStorage.getItem("token_id");
      this.setMenu([]);
      this.setToken(null);
      try {
        await authServices.logoutId({ token_identidad: tokenIdentidad });
        localStorage.clear();
        this.$router.push({ name: "login" }).catch((e) => {});
      } catch (e) {
        console.error(e);
      } finally {
        this.$store.commit("utils/setLoader", false);
      }
    },

    breakpoint() {
      if (this.$vuetify.breakpoint.sm) {
        return false;
      } else if (this.$vuetify.breakpoint.xs) {
        return false;
      } else if (this.$vuetify.breakpoint.md) {
        return true;
      } else if (this.$vuetify.breakpoint.lg) {
        return true;
      } else if (this.$vuetify.breakpoint.xl) {
        return true;
      } else {
        return true;
      }
    },
    getFullName() {
      setTimeout(() => {
        const { nombres, apellidos } = this.userInfo.user || {};

        // Extrae el primer nombre y el primer apellido
        const primerNombre = nombres ? nombres.split(" ")[0] : "";
        const primerApellido = apellidos ? apellidos.split(" ")[0] : "";
        const perfiles =
          this.userInfo?.puesto?.perfiles || this.userInfo?.perfiles || [];

        if (Array.isArray(perfiles) && perfiles.length >= 1) {
          if (perfiles.length == 1) {
            this.nombrePerfil = perfiles[0].nombre;
          } else {
            this.nombrePerfil = perfiles
              .map((perfil) => perfil.nombre)
              .join(", ");
          }
        }

        this.fullName = `${primerNombre} ${primerApellido}`.trim();
      }, 500);
    }
  },
  computed: {
    ...mapState(["userInfo"]),
    ...mapState("utils", {
      sideBar: "sideBar",
      menu: "menu"
    }),
    col1Breakpoint() {
      if (this.$vuetify.breakpoint.xs) {
        if (this.$vuetify.breakpoint.width < 500) {
          return 8;
        } else {
          return 7;
        }
      } else {
        return 7;
      }
    },
    col2Breakpoint() {
      if (this.$vuetify.breakpoint.xs) {
        if (this.$vuetify.breakpoint.width < 500) {
          return 4;
        } else {
          return 5;
        }
      } else {
        return 5;
      }
    }
  },
  mounted() {
    this.getFullName();
  }
};
</script>

<style scoped lang="scss">
.btn__hover {
  &:hover {
    background-color: #f4f7fd !important;
  }
}

.icon__color {
  color: #697182 !important;
}

.circular-container {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  overflow: hidden;
  background-color: #1c1e4d;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  margin-bottom: 5px;
}

.circular-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
}

.navbar-container {
  color: #1c1e4d;
  width: 30%;
  // padding-right: 1rem;
  justify-content: flex-end;
  gap: 1rem;
}

.user-name {
  line-height: 1;
  text-transform: none;
}

.wrap-name {
  min-width: 160px;
}

.wrap-text-sub {
  max-width: 228px;
  display: block;
  width: 100%;
  white-space: normal;
  word-break: break-word;
  text-align: right;
}

.logout-btn {
  padding: 0;
  min-width: auto;
  text-transform: none;
  color: #1c1e4d;
}

.logout-btn .v-btn__content {
  display: flex;
  align-items: center;
  gap: 0.35rem;
}

.user-avatar-icon {
  min-width: 40px;
}

@media screen and (max-width: 1024px) {
  .navbar-container {
    width: 60%;
  }
}

@media screen and (max-width: 600px) {
  .navbar-container {
    width: auto;
    padding-right: 0.5rem;
    gap: 0.5rem;
  }

  .wrap-name {
    min-width: auto;
  }
}

:deep(.v-btn.v-size--small) {
  font-size: 0.875rem;
  width: auto !important;
}
</style>
